import React, { useEffect, useRef, useState } from 'react';
import { formController } from '../controllers/formController';
import generalController from '../controllers/generalController';
import * as Components from './Components';
import { FormExtraParams } from '../types';

interface AppProps {}

function App({}: AppProps) {
  const appRef = useRef<HTMLDivElement>(null);
  const [targetComponent, setTargetComponent] = useState<string | null>(null);
  const [formExtraParams, setFormExtraParams] = useState<Omit<FormExtraParams, 'formType'>>({});

  useEffect(() => {
    // Get parent hidden inputs
    let formExtraParams: FormExtraParams = formController.getParentHiddenInputs(appRef.current);

    // Fetch and append from url query parameters to the extra parameters object
    const urlParams = new URLSearchParams(window.location.search);
    const modelCode = urlParams.get('modelCode');
    const modelOption = urlParams.get('modelOption');

    if (modelCode && modelOption) {
      formExtraParams.modelCode = modelCode;
      formExtraParams.modelOption = modelOption;
    }

    if (formExtraParams.formType) {
      // Get and add the current lang code
      const lang = generalController.detectLanguage();
      formExtraParams.language = lang;

      const formComponentKey = `${formExtraParams.formType}_Block`;

      if (formComponentKey in Components) {
        // Set the target component to be rendered
        setTargetComponent(formComponentKey);
        // Set formExtraParams except 'formType'
        const { formType, ...formExtraParamsRest } = formExtraParams;
        setFormExtraParams(formExtraParamsRest);
      } else {
        console.log(`Error: FormType, "${formExtraParams.formType}", is not found.`);
      }
    }
  }, []);

  const Component = targetComponent ? (Components as any)[targetComponent] : null;

  return (
    <div className="FormApp" ref={appRef}>
      {Component && <Component formExtraParams={formExtraParams} />}
    </div>
  );
}

export default App;
